<template>
  <ContentWrap>
    <el-tabs v-model="activeTab" @tab-change="handleTabChange">
      <el-tab-pane label="优惠券模板" name="template" />
      <el-tab-pane label="发放记录" name="record" />
    </el-tabs>

    <el-form
      v-if="activeTab === 'template'"
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="82px"
    >
      <el-form-item label="券名称" prop="name">
        <el-input
          v-model="queryParams.name"
          class="!w-220px"
          clearable
          placeholder="请输入券名称"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="发放方" prop="issuerType">
        <el-select v-model="queryParams.issuerType" class="!w-180px" clearable placeholder="全部">
          <el-option label="平台发放" value="PLATFORM" />
          <el-option label="商家发放" value="MERCHANT" />
        </el-select>
      </el-form-item>
      <el-form-item label="酒店" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          class="!w-220px"
          clearable
          filterable
          placeholder="请选择酒店"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-160px" clearable placeholder="全部">
          <el-option label="启用" :value="0" />
          <el-option label="停用" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon class="mr-5px" icon="ep:search" />搜索</el-button>
        <el-button @click="resetQuery"><Icon class="mr-5px" icon="ep:refresh" />重置</el-button>
        <el-button
          v-hasPermi="['hotel:coupon:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />新增优惠券
        </el-button>
      </el-form-item>
    </el-form>

    <el-form
      v-else
      ref="recordQueryFormRef"
      :inline="true"
      :model="recordQueryParams"
      class="-mb-15px"
      label-width="82px"
    >
      <el-form-item label="用户" prop="userId">
        <el-select v-model="recordQueryParams.userId" class="!w-180px" filterable clearable placeholder="请选择用户">
          <el-option v-for="u in staffOptions" :key="u.value" :label="u.label" :value="u.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="发放方" prop="issuerType">
        <el-select
          v-model="recordQueryParams.issuerType"
          class="!w-180px"
          clearable
          placeholder="全部"
        >
          <el-option label="平台发放" value="PLATFORM" />
          <el-option label="商家发放" value="MERCHANT" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="recordQueryParams.status" class="!w-160px" clearable placeholder="全部">
          <el-option label="未使用" :value="1" />
          <el-option label="已使用" :value="2" />
          <el-option label="已失效" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleRecordQuery"
          ><Icon class="mr-5px" icon="ep:search" />搜索</el-button
        >
        <el-button @click="resetRecordQuery"
          ><Icon class="mr-5px" icon="ep:refresh" />重置</el-button
        >
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap v-if="activeTab === 'template'">
    <el-table v-loading="loading" :data="list" border stripe empty-text="暂无优惠券模板">
      <el-table-column align="center" label="ID" prop="id" min-width="180" show-overflow-tooltip />
      <el-table-column label="券名称" prop="name" min-width="160" />
      <el-table-column align="center" label="发放方" prop="issuerType" width="110">
        <template #default="{ row }">
          <el-tag :type="row.issuerType === 'PLATFORM' ? 'success' : 'warning'">{{
            issuerLabel(row.issuerType)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="酒店" prop="shopId" min-width="150">
        <template #default="{ row }">{{ row.shopId ? shopName(row.shopId) : '平台通用' }}</template>
      </el-table-column>
      <el-table-column align="center" label="优惠内容" min-width="130">
        <template #default="{ row }">{{ discountText(row) }}</template>
      </el-table-column>
      <el-table-column align="center" label="门槛" width="110">
        <template #default="{ row }">{{ thresholdText(row.useThreshold) }}</template>
      </el-table-column>
      <el-table-column align="center" label="发放量" width="120">
        <template #default="{ row }"
          >{{ row.takeCount || 0 }} /
          {{ row.totalCount === -1 ? '不限' : row.totalCount }}</template
        >
      </el-table-column>
      <el-table-column align="center" label="领取方式" width="100">
        <template #default="{ row }">{{ row.takeType === 1 ? '用户自领' : '后台发放' }}</template>
      </el-table-column>
      <el-table-column align="center" label="有效期" min-width="300">
        <template #default="{ row }">{{
          formatValidRange(row.validStartTime, row.validEndTime)
        }}</template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="row.status === 0 ? 'success' : 'info'">{{
            row.status === 0 ? '启用' : '停用'
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" fixed="right" width="220">
        <template #default="{ row }">
          <el-button
            v-hasPermi="['hotel:coupon:update']"
            link
            type="primary"
            @click="openForm('update', row.id)"
            >编辑</el-button
          >
          <el-button v-hasPermi="['hotel:coupon:send']" link type="success" @click="openSend(row)"
            >发放</el-button
          >
          <el-button
            v-hasPermi="['hotel:coupon:delete']"
            link
            type="danger"
            @click="handleDelete(row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <ContentWrap v-else>
    <el-table v-loading="recordLoading" :data="recordList" border stripe empty-text="暂无发放记录">
      <el-table-column align="center" label="ID" prop="id" min-width="180" show-overflow-tooltip />
      <el-table-column label="券名称" prop="name" min-width="160" />
      <el-table-column align="center" label="用户ID" prop="userId" width="120" />
      <el-table-column align="center" label="发放方" prop="issuerType" width="110">
        <template #default="{ row }">{{ issuerLabel(row.issuerType) }}</template>
      </el-table-column>
      <el-table-column align="center" label="酒店" prop="shopId" min-width="150">
        <template #default="{ row }">{{ row.shopId ? shopName(row.shopId) : '平台通用' }}</template>
      </el-table-column>
      <el-table-column align="center" label="优惠内容" min-width="130">
        <template #default="{ row }">{{ discountText(row) }}</template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="90">
        <template #default="{ row }">
          <el-tag :type="couponStatusTag(row.status)">{{ couponStatusLabel(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="领取时间"
        prop="receiveTime"
        width="180"
      />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="使用时间"
        prop="useTime"
        width="180"
      />
    </el-table>
    <Pagination
      v-model:limit="recordQueryParams.pageSize"
      v-model:page="recordQueryParams.pageNo"
      :total="recordTotal"
      @pagination="getRecordList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle" width="720px">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-form-item label="券名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入优惠券名称" />
      </el-form-item>
      <el-form-item label="说明" prop="description">
        <el-input v-model="formData.description" type="textarea" placeholder="请输入优惠券说明" />
      </el-form-item>
      <el-form-item label="发放方" prop="issuerType">
        <el-radio-group v-model="formData.issuerType">
          <el-radio label="PLATFORM">平台发放</el-radio>
          <el-radio label="MERCHANT">商家发放</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠承担方" prop="benefitBearer">
        <el-radio-group v-model="formData.benefitBearer">
          <el-radio label="PLATFORM">平台承担</el-radio>
          <el-radio label="MERCHANT">商家承担</el-radio>
          <el-radio label="SPLIT">平台商家各半</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="抽佣基数" prop="commissionBaseType">
        <el-select v-model="formData.commissionBaseType" class="!w-320px">
          <el-option label="酒店原价" value="GROSS" />
          <el-option label="优惠后金额" value="AFTER_DISCOUNT" />
          <el-option label="商家应收金额" value="MERCHANT_RECEIVABLE" />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="formData.issuerType === 'MERCHANT' || formData.shopId"
        label="适用酒店"
        prop="shopId"
      >
        <el-select
          v-model="formData.shopId"
          class="!w-320px"
          clearable
          filterable
          placeholder="平台通用券可不选"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="领取方式" prop="takeType">
        <el-radio-group v-model="formData.takeType">
          <el-radio :label="1">用户自领</el-radio>
          <el-radio :label="2">后台发放</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="发放总量" prop="totalCount">
        <el-input-number v-model="formData.totalCount" :min="-1" :step="1" />
        <span class="ml-10px text-12px text-gray-500">-1 表示不限</span>
      </el-form-item>
      <el-form-item label="每人限领" prop="perUserLimit">
        <el-input-number v-model="formData.perUserLimit" :min="-1" :step="1" />
      </el-form-item>
      <el-form-item label="使用门槛" prop="useThreshold">
        <el-input-number v-model="useThresholdYuan" :min="0" :precision="2" :step="10" />
        <span class="ml-10px">元</span>
      </el-form-item>
      <el-form-item label="优惠类型" prop="discountType">
        <el-radio-group v-model="formData.discountType">
          <el-radio :label="1">满减</el-radio>
          <el-radio :label="2">折扣</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="formData.discountType === 1" label="优惠金额" prop="discountPrice">
        <el-input-number v-model="discountPriceYuan" :min="0.01" :precision="2" :step="10" />
        <span class="ml-10px">元</span>
      </el-form-item>
      <template v-else>
        <el-form-item label="折扣比例" prop="discountPercent">
          <el-input-number v-model="formData.discountPercent" :min="1" :max="99" :step="1" />
          <span class="ml-10px text-12px text-gray-500">85 表示 8.5 折</span>
        </el-form-item>
        <el-form-item label="折扣封顶" prop="discountLimitPrice">
          <el-input-number v-model="discountLimitYuan" :min="0" :precision="2" :step="10" />
          <span class="ml-10px">元，0 表示不封顶</span>
        </el-form-item>
      </template>
      <el-form-item label="有效期" prop="validRange">
        <el-date-picker
          v-model="validRange"
          type="datetimerange"
          format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="YYYY-MM-DD HH:mm:ss"
          class="!w-420px"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio :label="0">启用</el-radio>
          <el-radio :label="1">停用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <Dialog v-model="sendDialogVisible" title="发放优惠券" width="560px">
    <el-form ref="sendFormRef" :model="sendFormData" :rules="sendFormRules" label-width="100px">
      <el-form-item label="优惠券">
        <el-input :model-value="sendTemplateName" disabled />
      </el-form-item>
      <el-form-item label="用户ID" prop="userIdsText">
        <el-input
          v-model="sendFormData.userIdsText"
          type="textarea"
          :rows="5"
          placeholder="多个用户ID用逗号、空格或换行分隔"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="submitSend">发 放</el-button>
      <el-button @click="sendDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { dateFormatter, formatDate } from '@/utils/formatTime'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import * as CouponApi from '@/api/hotel/coupon'
import type { HotelCouponTemplateVO } from '@/api/hotel/coupon'

defineOptions({ name: 'HotelCoupon' })

const { staffOptions, staffMap, loadStaffs } = useStaff()
const message = useMessage()
const { t } = useI18n()

const activeTab = ref('template')
const shopList = ref<any[]>([])
const loading = ref(false)
const total = ref(0)
const list = ref<HotelCouponTemplateVO[]>([])
const queryFormRef = ref()
const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  name: undefined,
  issuerType: undefined,
  shopId: undefined,
  status: undefined
})

const recordLoading = ref(false)
const recordTotal = ref(0)
const recordList = ref<any[]>([])
const recordQueryFormRef = ref()
const recordQueryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  userId: undefined,
  issuerType: undefined,
  status: undefined
})

const getShopList = async () => {
  shopList.value = (await getShopSimpleList()) || []
}

const getList = async () => {
  loading.value = true
  try {
    const data = await CouponApi.getCouponTemplatePage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const getRecordList = async () => {
  recordLoading.value = true
  try {
    const data = await CouponApi.getCouponRecordPage(recordQueryParams)
    recordList.value = data.list || []
    recordTotal.value = data.total || 0
  } finally {
    recordLoading.value = false
  }
}

const handleTabChange = () => {
  activeTab.value === 'template' ? getList() : getRecordList()
}
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}
const resetQuery = () => {
  queryFormRef.value?.resetFields()
  handleQuery()
}
const handleRecordQuery = () => {
  recordQueryParams.pageNo = 1
  getRecordList()
}
const resetRecordQuery = () => {
  recordQueryFormRef.value?.resetFields()
  handleRecordQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref<'create' | 'update'>('create')
const formRef = ref()
const validRange = ref<string[]>([])
const formData = ref<HotelCouponTemplateVO>(emptyForm())

function normalizeDateTime(value?: string | number | null) {
  if (value === undefined || value === null || value === '') return ''
  if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) {
    return formatDate(Number(value))
  }
  return value.replace('T', ' ').slice(0, 19)
}

const formRules = reactive({
  name: [{ required: true, message: '券名称不能为空', trigger: 'blur' }],
  issuerType: [{ required: true, message: '发放方不能为空', trigger: 'change' }],
  discountType: [{ required: true, message: '优惠类型不能为空', trigger: 'change' }],
  validRange: [{ required: true, message: '有效期不能为空', trigger: 'change' }]
})

const useThresholdYuan = computed({
  get: () => Number(formData.value.useThreshold || 0) / 100,
  set: (value: number) => {
    formData.value.useThreshold = Math.round(Number(value || 0) * 100)
  }
})
const discountPriceYuan = computed({
  get: () => Number(formData.value.discountPrice || 0) / 100,
  set: (value: number) => {
    formData.value.discountPrice = Math.round(Number(value || 0) * 100)
  }
})
const discountLimitYuan = computed({
  get: () => Number(formData.value.discountLimitPrice || 0) / 100,
  set: (value: number) => {
    formData.value.discountLimitPrice = Math.round(Number(value || 0) * 100)
  }
})

function emptyForm(): HotelCouponTemplateVO {
  return {
    name: '',
    description: '',
    issuerType: 'PLATFORM',
    benefitBearer: 'PLATFORM',
    commissionBaseType: 'AFTER_DISCOUNT',
    shopId: undefined,
    status: 0,
    takeType: 1,
    totalCount: -1,
    perUserLimit: 1,
    useThreshold: 0,
    discountType: 1,
    discountPrice: 0,
    discountPercent: 85,
    discountLimitPrice: 0,
    validStartTime: '',
    validEndTime: ''
  }
}

const openForm = async (type: 'create' | 'update', id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增优惠券' : '编辑优惠券'
  formType.value = type
  formData.value = emptyForm()
  validRange.value = []
  if (id) {
    formLoading.value = true
    try {
      const data = await CouponApi.getCouponTemplate(id)
      formData.value = data
      validRange.value = [
        normalizeDateTime(data.validStartTime),
        normalizeDateTime(data.validEndTime)
      ]
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  const valid = await formRef.value?.validate()
  if (!valid) return
  if (!validRange.value || validRange.value.length !== 2) {
    message.warning('请选择有效期')
    return
  }
  if (formData.value.issuerType === 'MERCHANT' && !formData.value.shopId) {
    message.warning('商家发放必须选择酒店')
    return
  }
  formData.value.validStartTime = validRange.value[0]
  formData.value.validEndTime = validRange.value[1]
  formLoading.value = true
  try {
    if (formType.value === 'create') {
      await CouponApi.createCouponTemplate(formData.value)
      message.success(t('common.createSuccess'))
    } else {
      await CouponApi.updateCouponTemplate(formData.value)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const handleDelete = async (id: string | number) => {
  await message.delConfirm()
  await CouponApi.deleteCouponTemplate(id)
  message.success(t('common.delSuccess'))
  await getList()
}

const sendDialogVisible = ref(false)
const sendTemplateName = ref('')
const sendFormRef = ref()
const sendFormData = reactive({ templateId: undefined as any, userIdsText: '' })
const sendFormRules = reactive({
  userIdsText: [{ required: true, message: '请输入用户ID', trigger: 'blur' }]
})

const openSend = (row: HotelCouponTemplateVO) => {
  sendFormData.templateId = row.id
  sendFormData.userIdsText = ''
  sendTemplateName.value = row.name
  sendDialogVisible.value = true
}

const submitSend = async () => {
  const valid = await sendFormRef.value?.validate()
  if (!valid) return
  const userIds = sendFormData.userIdsText
    .split(/[\s,，]+/)
    .map((id) => id.trim())
    .filter(Boolean)
  if (userIds.length === 0) {
    message.warning('请输入用户ID')
    return
  }
  const count = await CouponApi.sendCoupon({ templateId: sendFormData.templateId, userIds })
  message.success(`已发放 ${count} 张优惠券`)
  sendDialogVisible.value = false
  await getList()
  if (activeTab.value === 'record') await getRecordList()
}

function issuerLabel(value: string) {
  return value === 'PLATFORM' ? '平台发放' : '商家发放'
}
function shopName(id: string | number) {
  const item = shopList.value.find((shop) => String(shop.id) === String(id))
  return item?.name || id
}
function yuan(value?: number) {
  const n = Number(value || 0) / 100
  return Number.isInteger(n) ? String(n) : n.toFixed(2)
}
function thresholdText(value?: number) {
  return Number(value || 0) > 0 ? `满 ${yuan(value)} 元` : '无门槛'
}
function discountText(row: any) {
  return row.discountType === 1
    ? `减 ${yuan(row.discountPrice)} 元`
    : `${Number(row.discountPercent || 0) / 10} 折`
}
function formatValidRange(start?: string | number | null, end?: string | number | null) {
  const from = normalizeDateTime(start)
  const to = normalizeDateTime(end)
  return from && to ? `${from} 至 ${to}` : '-'
}
function couponStatusLabel(status: number) {
  return status === 1 ? '未使用' : status === 2 ? '已使用' : status === 4 ? '已锁定' : '已失效'
}
function couponStatusTag(status: number) {
  return status === 1 ? 'success' : status === 2 ? 'info' : status === 4 ? 'warning' : 'danger'
}

onMounted(() => { loadStaffs();
  getShopList()
  getList()
})
</script>
